import { render, staticRenderFns } from "./network.vue?vue&type=template&id=21a8c4ba&scoped=true"
import script from "./network.vue?vue&type=script&lang=js"
export * from "./network.vue?vue&type=script&lang=js"
import style0 from "./network.vue?vue&type=style&index=0&id=21a8c4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8c4ba",
  null
  
)

export default component.exports